import { useReportMetricsContextV2 } from 'src/contexts/ReportMetricsContext/ReportMetricsContextV2';
import PurchaseReportTableV2 from 'src/tables/PurchaseTable/PurchaseReportTableV2';

import { ReportsPageLayout } from '../Reports/ReportsPageLayout';
import * as styles from './ReportsPurchasePage.css';

export function ReportsPurchasePage() {
  // All the child components treat tempReportConfig as the reportConfig
  // to get its latest state
  const {
    tempReportConfig: reportConfig,
    reportMetrics,
    reportSummary,
    reportValueTypes,
  } = useReportMetricsContextV2();

  return (
    <ReportsPageLayout
      reportConfig={reportConfig}
      reportTable={
        <PurchaseReportTableV2
          className={styles.table}
          metricsData={reportMetrics}
          summaryData={reportSummary}
          report={reportConfig}
          reportValueTypes={reportValueTypes}
        />
      }
    />
  );
}
